import React from 'react';
import '../Style/SiteLoader.css';

function SiteLoader() {
  return (
    <div className="site-loader-screen" aria-live="polite">
      <div className="ui-loader term" role="status" aria-label="Loading">
        <div className="term-bar">
          <span className="dot" />
          <span className="dot" />
          <span className="dot" />
          <div className="term-title">rin0700.com</div>
        </div>

        <div className="term-body">
          <div className="line">
            <b>$</b> rin run build
          </div>
          <div className="line muted">› compiling modules...</div>
          <div className="line">
            <span className="tag ok">✓</span> assets optimized
          </div>
          <div className="line">
            <span className="tag run">●</span> generating bundles
            <span className="cursor" aria-hidden="true" />
          </div>

          <div className="progress">
            <span className="fill" />
            <span className="glint" aria-hidden="true" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SiteLoader;
